import React, { useEffect, useState } from 'react';
import { useLocation } from '@uhg-abyss/web/tools/reactRouterTools/reactRouterDom';
import { LoadingOverlay } from '@uhg-abyss/web/ui/LoadingOverlay';
import PropTypes from 'prop-types';
import { config } from '@uhg-abyss/web/tools/config';
import { useUserInfo } from '@src/hooks/useUserInfo';
import { storage } from '@uhg-abyss/web/tools/storage';
import {
  onBreadcrumbsHandler,
  // onBreadcrumbsHandlerIgnoreLatest,
  // onBreadcrumbsHandlerMultiLevel,
} from '@src/hooks/useBreadcrumbs';
export const ProtectedRoute = ({ Component, routeName, ...rest }) => {
  const [setBreadcrumbs] = onBreadcrumbsHandler();

  const [authScriptLoaded, setAuthScriptLoaded] = useState(false);
  const [userInfo, getUserInfo] = useUserInfo();
  const location = useLocation();

  useEffect(() => {
    if (!document.getElementById('auth-script')) {
      const script = document.createElement('script');
      script.src = config('UHC_AUTH_SCRIPT');
      script.async = false;
      script.id = 'auth-script';

      script.onload = () => {
        getUserInfo();
        setAuthScriptLoaded(true);
      };

      document.head.appendChild(script);
    } else {
      getUserInfo();
      setAuthScriptLoaded(true);
    }
  }, []);

  const breadcrumbsHandler = () => {
    setBreadcrumbs(location);
  };

  useEffect(() => {
    // Your common logic here
    // setPath({ location, navigate, params });
    breadcrumbsHandler();
  }, [location]);

  const isAuthenticated = authScriptLoaded && userInfo?.data?.uuid;

  return isAuthenticated ? (
    <Component {...rest} />
  ) : (
    <LoadingOverlay
      loadingTitle="Please Wait"
      loadingMessage={
        storage.local.get('IS_SIGNED_OUT') ? 'Signing out' : 'Signing in'
      }
      ariaLoadingLabel={
        storage.local.get('IS_SIGNED_OUT') ? 'Signing out' : 'Signing in'
      }
      isLoading
      width="60%"
    />
  );
};

ProtectedRoute.propTypes = {
  Component: PropTypes.elementType.isRequired,
  routeName: PropTypes.string,
};

ProtectedRoute.defaultProps = {
  routeName: 'Unknown',
};
